import BaseEnumType from "../base-enum-type";

export const PlayerYears = Object.freeze({
    FR: new BaseEnumType("FR", "Fr"),
    SO: new BaseEnumType("SO", "So"),
    JR: new BaseEnumType("JR", "Jr"),
    SR: new BaseEnumType("SR", "Sr")
});
